if (!customElements.get('product-review-stars')) {
  customElements.define(
    'product-review-stars',
    class ProductSLider extends HTMLElement {
      constructor() {
        super();
        this.STORE_NAME = 'lime-lace-interiors.myshopify.com';
        this.API_ENDPOINT = 'https://api.reviews.io/merchant/reviews?store=';

        this.starsList = this.querySelector('.review-stars--list');
        this.stars = this.starsList.querySelectorAll('.star');
        this.description = this.querySelector('[data-description]');
        this.button = this.querySelector('button');
        this.buttonText = this.querySelector('.button-text');
        this.visibleDescription = this.querySelector('[data-visible-description]');

        this.reviewsTabDisclosure = document.querySelector('tab-details-disclosure[data-reviews-tab]');
        this.reviewsTabButton = document.querySelector('tab-container button[data-reviews-tab]');

        this.button.addEventListener('click', this.handleButtonClick.bind(this));
      }
      connectedCallback() {
        if (sessionStorage.getItem('reviews-io-store-stars') != null) {
          try {
            let reviewsData = JSON.parse(sessionStorage.getItem('reviews-io-store-stars'));
            this.showStars(reviewsData);
          } catch (err) {
            this.classList.add('hidden');
          }
        } else {
          fetch(`${this.API_ENDPOINT}${this.STORE_NAME}`)
            .then((res) => res.json())
            .then((data) => {
              if (data.stats && data.stats.average_rating) {
                let reviewsData = data.stats;
                sessionStorage.setItem('reviews-io-store-stars', JSON.stringify(reviewsData));
                this.showStars(reviewsData);
              }
            })
            .catch((err) => {
              this.classList.add('hidden');
            });
        }
      }
      showStars(data) {
        this.description.innerText = `Store rated ${data.average_rating}, with a total of ${data.total_reviews} reviews`;
        if (this.visibleDescription) {
          this.visibleDescription.innerText = `${data.average_rating} (out of ${data.total_reviews} reviews)`;
        }
        let averageRating = parseFloat(data.average_rating);
        let minWholeStar = parseInt(Math.floor(averageRating));
        let fraction = averageRating - minWholeStar;
        if (fraction > 0.9) {
          fraction = 1.0;
        } else if (fraction > 0.6) {
          fraction = 0.7;
        } else if (fraction < 0.3) {
          fraction = 0.3;
        }

        this.stars.forEach((star, index) => {
          let indexNonZero = index + 1;
          let ratingValue = indexNonZero <= minWholeStar ? '1.0' : fraction;
          star.classList.remove('hidden');
          star.style.setProperty('--rating', ratingValue);
        });
        this.buttonText.classList.remove('hidden');
        let animatedElements = this.querySelectorAll('.animate--slide-in');
        if (animatedElements.length) {
          animatedElements.forEach((element) => {
            element.classList.add('scroll-trigger');
          });
        }
      }
      handleButtonClick(e) {
        e.preventDefault();
        if (window.innerWidth < 990 && this.reviewsTabDisclosure != null) {
          this.reviewsTabDisclosure.open();
          this.reviewsTabDisclosure.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        } else if (this.reviewsTabButton != null) {
          let tabContainer = this.reviewsTabButton.closest('tab-container');
          tabContainer.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
          let tabId = parseInt(this.reviewsTabButton.getAttribute('aria-controls').replace('panel-', ''));
          tabContainer.selectedTab = tabId;
        }
      }
    }
  );
}
